<template>
    <section v-if='isShowPackages' class='packages' :style='{
        "background-position-y": bgPositionY
    }'>

        <!-- heading -->
        <div class='packages__heading grid'>
            <div class='packages__heading__col packages__heading__col--heading grid__col'>
                <h2 v-for='i in 2' class='packages__heading__title' :class='`packages__heading__title--${i}`'>
                    <template v-if='headingLine1 || headingLine2'>
                        <div v-if='headingLine1' class='packages__heading__title__line packages__heading__title__line--1' v-html='headingLine1' />
                        <div v-if='headingLine2' class='packages__heading__title__line packages__heading__title__line--2' v-html='headingLine2' />
                    </template>
                    <template v-else>
                        <div class='packages__heading__title__line packages__heading__title__line--1' v-text='"Packages"' />
                        <div class='packages__heading__title__line packages__heading__title__line--2' v-text='"To Die For"' />
                    </template>
                </h2>
            </div>

            <div class='packages__heading__col packages__heading__col--copy grid__col'>
                <div v-if='description' class='packages__heading__copy copy' v-html='description' />
                <div v-else class='packages__heading__copy copy'>
                    <p>Reserve your spot in hell today! <strong>Get ready for Season One premiere on Prime Video in January.</strong></p>
                    <p>Preorder the package of your choice and you'll get early access to the first two episodes of the season, plus exclusive merch only available during this presale.</p>
                    <p>And honey, the perks are to die for, but don&apos;t take our word for it, see for yourself:</p>
                </div>
            </div>
        </div>

        <!-- packages -->
        <div class='packages__container' id='packages__container' ref='container'>

            <div class='packages__container__membrane'>
                <template v-for='(pack, key, i) in packages'>
                    <PackageBlock
                        v-if='pack?.product'
                        :package='pack'
                        :slug='key'
                        :isCtaBold='key === "ultimate"'
                        :index='i'
                        :key='key'
                        :maxPackageItems='maxPackageItems'
                        ref='package'
                    />
                </template>

            </div>
        </div>
    </section>
</template>

<script>
import { mapState } from 'pinia';
import { useScrollStore } from '^/stores/scroll';

import PackageBlock from '^/components/blocks/PackageBlock.vue';

export default {
    name: 'PackagesTier',
    data() {
        return {
            headingLine1: window.app.presalePackagesText?.heading?.line_1 || null,
            headingLine2: window.app.presalePackagesText?.heading?.line_2 || null,
            description: window.app.presalePackagesText?.description || null,

            packages: window.app.presalePackages || null,

            elY: 0,
            elHeight: 0
        }
    },
    computed: {
        ...mapState(useScrollStore, [
            'scrollY',
            'winWidth',
            'winHeight'
        ]),
        isShowPackages () {
            return this.packages && Object.keys(this.packages).length > 0
        },
        bgPositionY () {
            const { scrollY, elY, elHeight, winHeight } = this;
            const top = elY - winHeight;
            const bottom = elY + elHeight;

            if (scrollY < top) {
                return '0%';
            } else if (scrollY > bottom) {
                return '-100%';
            } else {
                const offset = this.mapRange(scrollY, top, bottom, 0, -100);
                return `${offset}%`;
            }
        },
        maxPackageItems () {
            return Math.max(...Object.values(this.packages).map(pack => pack.package_items.length));
        }
    },
    mounted () {
        this.measure();
        window.addEventListener('appResize', this.resize);
    },
    beforeUnmount () {
        window.removeEventListener('appResize', this.resize);
    },
    methods: {
        measure () {
            if (!this.isShowPackages) return

            const elBox = this.$el.getBoundingClientRect();

            this.elY = elBox.top;
            this.elHeight = elBox.height;
        },
        resize () {
            this.measure();
        },
        mapRange (input, in_min, in_max, out_min, out_max) {
            return ((input - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
        }
    },
    components: {
        PackageBlock
    }
};
 </script>